import { render } from "./TermsOfService.vue?vue&type=template&id=0fdcdd22"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/MaintenancePack/TermsOfService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fdcdd22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fdcdd22', __exports__)) {
    api.reload('0fdcdd22', __exports__)
  }
  
  module.hot.accept("./TermsOfService.vue?vue&type=template&id=0fdcdd22", () => {
    api.rerender('0fdcdd22', render)
  })

}


export default __exports__